import React from 'react';
import MultiPanelHero from '../hero/MultiPanelHero';

const HeroSection = () => {
  return <MultiPanelHero />;
};

export default HeroSection;
